"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _recompose = require("recompose");
var _Chart = require("../../Chart");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } /* eslint-disable react/prop-types */
/**
 * This HOC renders the Chart that is passed into it
 * wrapped in a component that also renders a tooltip, whose position is determined
 * by consuming the `onHover` prop of the InnerComponent.
 *
 * Configurable by accepting a `tooltipComponent` prop. Tooltip
 * is rendered in HTML and NOT SVG as there are problems w/ foreign element in
 * some browsers.
 */
var withTooltip = function withTooltip(InnerComponent) {
  var _Class;
  return _Class = /*#__PURE__*/function (_React$Component) {
    (0, _inherits2["default"])(_Class, _React$Component);
    function _Class(props) {
      var _this;
      (0, _classCallCheck2["default"])(this, _Class);
      _this = _callSuper(this, _Class, [props]);
      _this.onHover = _this.onHover.bind((0, _assertThisInitialized2["default"])(_this));
      _this.state = {};
      return _this;
    }
    (0, _createClass2["default"])(_Class, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this2 = this;
        var _this$props = this.props,
          plot = _this$props.plot,
          showCrosshair = _this$props.showCrosshair;
        if (showCrosshair && plot && !this.crosshair) {
          this.crosshair = (0, _Chart.createCrosshair)(plot);
          plot.onResize(function (_ref) {
            var height = _ref.height;
            return _this2.crosshair.height(height);
          });
        }
      }
    }, {
      key: "onHover",
      value: function onHover(props) {
        var hover = props.hover;
        if (hover === null) {
          if (this.crosshair) this.crosshair.hide();
          this.setState({
            hover: null
          });
          return;
        }
        if (!this.state.hover || this.state.hover.anchorX !== hover.anchorX || this.state.hover.anchorY !== hover.anchorY) {
          if (this.crosshair) this.crosshair.drawAt({
            x: hover.anchorX,
            y: hover.anchorY
          });
          this.setState({
            hover: _objectSpread({}, hover)
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
          series = _this$props2.series,
          flyoutComponent = _this$props2.flyoutComponent,
          tooltipComponent = _this$props2.tooltipComponent,
          tooltipRows = _this$props2.tooltipRows,
          tooltipTitle = _this$props2.tooltipTitle,
          tooltipWidth = _this$props2.tooltipWidth,
          plot = _this$props2.plot,
          tooltipRenderer = _this$props2.tooltipRenderer;
        var plotOffset = plot ? plot.originToRoot() : {
          x: 0,
          y: 0
        };
        var hoverProps = this.state.hover ? _objectSpread({
          height: _Chart.BasicTooltip.getBaseHeight(series.length),
          width: tooltipWidth || 150,
          isAnchoredX: true
        }, this.state.hover) : null;
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            pointerEvents: 'none',
            position: 'absolute',
            overflow: 'visible'
          },
          width: '100%',
          height: '100%'
        }, /*#__PURE__*/_react["default"].createElement(InnerComponent, (0, _extends2["default"])({}, this.props, {
          onHover: this.onHover
        })), hoverProps && /*#__PURE__*/_react["default"].cloneElement(flyoutComponent, hoverProps, tooltipComponent ? /*#__PURE__*/_react["default"].cloneElement(tooltipComponent, hoverProps) : /*#__PURE__*/_react["default"].createElement(_Chart.BasicTooltip, (0, _extends2["default"])({
          rows: tooltipRows,
          title: tooltipTitle,
          plotOffset: plotOffset,
          tooltipRenderer: tooltipRenderer,
          testId: "chart-tooltip"
        }, hoverProps))));
      }
    }]);
    return _Class;
  }(_react["default"].Component), (0, _defineProperty2["default"])(_Class, "displayName", "withTooltip(".concat((0, _recompose.getDisplayName)(InnerComponent), ")")), _Class;
};
var _default = exports["default"] = withTooltip;
//# sourceMappingURL=withTooltip.js.map